import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import { menuItems } from '../../services/employeePanel.menuItems';
import pubsub from 'pubsub-js';
import { updateSidebarSelectedItem } from '../../../../services/redux/employee/sidebar/actions';

class WelcomePage extends Component {
    render() {
        const { history, roleName, updateSidebarSelectedItem } = this.props;
        const userMenuItems = menuItems.filter(item =>
            item.roles.includes(roleName)
        );
        const navigationButtons = userMenuItems.map(item => {
            return (
                <button
                    key={item.id}
                    type="button"
                    className="btn btn-default btn-bordered btn-lg m-lg welcome"
                    onClick={() => {
                        if (item.value) {
                            updateSidebarSelectedItem(item.value);
                            pubsub.publish('refreshSideMenu');
                            history.push(item.value);
                        }
                    }}
                >
                    <span className={item.iconClass} aria-hidden="true" />
                    <br />
                    <p className="m">
                        <strong>{item.label}</strong>
                    </p>
                </button>
            );
        });
        return (
            <div>
                <div className="row well text-center">
                    <h2 className="ml">Welcome to MasterLink Pro</h2>
                    <div
                        className="center-block pt"
                        style={{ maxWidth: '1000px'}}
                    >
                        {navigationButtons}
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => ({
    user: state.authentication.user,
    roleName: state.authentication.user
        ? state.authentication.user.roleName
        : ''
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ updateSidebarSelectedItem }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(WelcomePage));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/WelcomePage/index.js